import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ width = "70%" }) => css`
    width: ${width};
    position: relative;
    overflow: hidden;
    left: 15%;

    .eye-icon {
      position: absolute;
      top: 50%;
      right: 5px;
      cursor: pointer;
    }
  `}
`;
export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    padding-bottom: 1px;
    color: ${theme.colors.gray}!important;
    font-size: ${theme.font.sizes.medium} !important;
    font-family: Roboto !important;
    line-height: 2.5rem;
  `}
`;
export const Timer = styled.p`
  ${({ theme }) => css`
    padding-left: 1rem;
    font-size: 1.5rem;
    border-radius: 5px;
    line-height: 4rem;

    width: 100%;
    height: 3.8rem;
    margin-bottom: 0.5rem;
    ::placeholder {
      color: ${theme.colors.gray};
      font-style: italic;
      font-size: 1.5rem;
      font-family: Roboto !important;
    }
  `}
`;
